/** @typedef {{ id: string, name: string, primary: string, primaryDark: string, primaryLight: string, secondary: string, accent: string, gradient: string }} ThemePreset */

export const THEME_STORAGE_KEY = 'revivepay-color-theme';
export const DEFAULT_THEME_ID = 'revive-blue';

/** @type {ThemePreset[]} */
export const THEME_PRESETS = [
  {
    id: 'revive-blue',
    name: 'Revive Blue',
    primary: '#154A8A',
    primaryDark: '#0d3568',
    primaryLight: '#5c6bc0',
    secondary: '#3949ab',
    accent: '#FF8C42',
    gradient: 'linear-gradient(90deg, #154A8A 0%, #3949ab 50%, #5c6bc0 100%)',
  },
  {
    id: 'ocean-teal',
    name: 'Ocean Teal',
    primary: '#00695c',
    primaryDark: '#004d40',
    primaryLight: '#4db6ac',
    secondary: '#00897b',
    accent: '#ff7043',
    gradient: 'linear-gradient(90deg, #00695c 0%, #00897b 50%, #4db6ac 100%)',
  },
  {
    id: 'royal-purple',
    name: 'Royal Purple',
    primary: '#6a1b9a',
    primaryDark: '#4a148c',
    primaryLight: '#ab47bc',
    secondary: '#8e24aa',
    accent: '#ffa726',
    gradient: 'linear-gradient(90deg, #6a1b9a 0%, #8e24aa 50%, #ab47bc 100%)',
  },
  {
    id: 'forest-green',
    name: 'Forest Green',
    primary: '#2e7d32',
    primaryDark: '#1b5e20',
    primaryLight: '#66bb6a',
    secondary: '#388e3c',
    accent: '#ffb74d',
    gradient: 'linear-gradient(90deg, #2e7d32 0%, #388e3c 50%, #66bb6a 100%)',
  },
  {
    id: 'slate',
    name: 'Slate',
    primary: '#455a64',
    primaryDark: '#263238',
    primaryLight: '#78909c',
    secondary: '#546e7a',
    accent: '#ef5350',
    gradient: 'linear-gradient(90deg, #455a64 0%, #546e7a 50%, #78909c 100%)',
  },
  {
    id: 'crimson',
    name: 'Crimson',
    primary: '#c62828',
    primaryDark: '#b71c1c',
    primaryLight: '#ef5350',
    secondary: '#d32f2f',
    accent: '#ff9800',
    gradient: 'linear-gradient(90deg, #c62828 0%, #d32f2f 50%, #ef5350 100%)',
  },
  {
    id: 'indigo',
    name: 'Indigo',
    primary: '#283593',
    primaryDark: '#1a237e',
    primaryLight: '#5c6bc0',
    secondary: '#3949ab',
    accent: '#26c6da',
    gradient: 'linear-gradient(90deg, #283593 0%, #3949ab 50%, #5c6bc0 100%)',
  },
  {
    id: 'amber-gold',
    name: 'Amber Gold',
    primary: '#f57f17',
    primaryDark: '#e65100',
    primaryLight: '#ffb74d',
    secondary: '#ff8f00',
    accent: '#5d4037',
    gradient: 'linear-gradient(90deg, #f57f17 0%, #ff8f00 50%, #ffb74d 100%)',
  },
];

export const getThemePresetById = (id) =>
  THEME_PRESETS.find((p) => p.id === id) ?? THEME_PRESETS.find((p) => p.id === DEFAULT_THEME_ID);

export const getStoredThemeId = () => {
  try {
    const stored = localStorage.getItem(THEME_STORAGE_KEY);
    if (stored && THEME_PRESETS.some((p) => p.id === stored)) return stored;
  } catch {
    /* ignore */
  }
  return DEFAULT_THEME_ID;
};

export const setStoredThemeId = (id) => {
  try {
    localStorage.setItem(THEME_STORAGE_KEY, id);
  } catch {
    /* ignore */
  }
};

/** Sync CSS variables for Tailwind / non-MUI usage */
export const applyThemeCssVariables = (preset) => {
  const root = document.documentElement;
  root.style.setProperty('--app-primary', preset.primary);
  root.style.setProperty('--app-primary-dark', preset.primaryDark);
  root.style.setProperty('--app-primary-light', preset.primaryLight);
  root.style.setProperty('--app-secondary', preset.secondary);
  root.style.setProperty('--app-accent', preset.accent);
  root.style.setProperty('--app-gradient', preset.gradient);
};
